module.exports = __webpack_public_path__ + "static/mevia-caseimg-0cf72029c27a77860bf8d852612f1e0f.jpg";